import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import telemedicine_45fence_45global from "/vercel/path0/middleware/telemedicine-fence.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  telemedicine_45fence_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.ts"),
  guest: () => import("/vercel/path0/middleware/guest.ts")
}